import { USER_SUPERHIGHLIGHT_SERVICE } from '../paths';
import { apiCall } from 'api';

export const getSuperHighlightService = (params = {}) => {
  const { claroLiteConfig, ...restParams } = params;
  restParams.api_version = null;
  return apiCall.get(USER_SUPERHIGHLIGHT_SERVICE, {
    params: { ...restParams  },
  });
};
